// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ss-1";
export var stateContainer = "_ss-0";